export default function VideoInvito() {
    return (
      <div className="relative w-full  pt-[56.25%]"> {/* 16:9 aspect ratio */}
        <iframe
          className="absolute top-0 left-0 w-full rounded-4xl h-full border-0 rounded-[40px]"
          loading="lazy"
          title="Gumlet video player"
          src="https://play.gumlet.io/embed/68088e5843b66634dcec708f?preload=false&autoplay=false&loop=false&background=false&disable_player_controls=false"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen"
        ></iframe>
      </div>
    );
  }
  
 